import { Controller } from "react-hook-form";
import { FormattedMessage } from "react-intl";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

export default function ProfilePhoneField({ control, errors }) {
  return (
    <div className="form-label row">
      <div className="col-lg-4">
        <label>
          <FormattedMessage id="mobile" />:
        </label>
      </div>
      <div className="col-lg-8">
        <div className="row">
          <div className="col-lg-12 position-relative">
            <div
              className={`form-label-container mobile ${
                errors?.phoneNumber?.message ? "mb-3" : ""
              }`}
              dir="ltr"
            >
              <Controller
                control={control}
                name="phoneNumber"
                render={({ field: { ref, ...field } }) => (
                  <PhoneInput
                    {...field}
                    inputExtraProps={{
                      ref,
                      required: true,
                      autoFocus: true,
                    }}
                    inputStyle={{
                      direction: "ltr",
                    }}
                    country="eg"
                    placeholder="+201121221501"
                    className={`form-control ${
                      errors.phoneNumber ? "is-invalid" : ""
                    }`}
                  />
                )}
              />
            </div>
            <span
              className="position-absolute"
              style={{ top: "10px", insetInlineEnd: "0px", color: "red" }}
            >
              *
            </span>
          </div>
        </div>
        <div className="col-12 mb-3">
          {errors?.phoneNumber?.message && (
            <div role="alert" className="alert alert-danger py-1">
              {errors.phoneNumber.message}
            </div>
          )}
        </div>
        <div className="col-12">
          {errors?.countryCode?.message && (
            <div role="alert" className="alert alert-danger py-1">
              {errors.countryCode.message}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
